import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Accordion2 as Accordion } from "@qgiv/core-donor";
import ConnectedStoreItemsList from "./ConnectedStoreItemsList";

const StoreCategoriesList = ({ controlId, products, sectionHeading }) => {
    // We only want categories that have active products set to display in registration
    const productCategories = products.filter(
        (productCategory) =>
            productCategory.products.length > 0 &&
            productCategory.products.some((product) => product.featureInReg),
    );

    const categoriesIndexArr = productCategories.map(
        (category, index) => index,
    );

    // Setting this as default of null begins with all panels in accordion collapsed
    // If you want a specific panel to begin open set it to the index number
    const [activeEventKeys, setActiveEventKeys] = useState(categoriesIndexArr);
    const panelClasses = cx("panel", "accordion__panel");

    // Accessibility - needs to be passed in here because this labels
    // composition will change based on how the accordion is used
    const getAriaLabel = (categoryName) =>
        `${sectionHeading}: ${categoryName} Category`;

    return (
        <div className="store-list">
            <Accordion
                activeEventKeys={activeEventKeys}
                onToggle={setActiveEventKeys}
            >
                {productCategories.map(({ id, name }, index) => (
                    <div key={id} className={panelClasses}>
                        <Accordion.Toggle
                            element={Accordion.Header}
                            eventKey={index}
                            ariaLabel={getAriaLabel(name)}
                        >
                            <strong>{name}</strong>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={index}>
                            <ConnectedStoreItemsList
                                storeCategoryId={id}
                                controlId={controlId}
                            />
                        </Accordion.Collapse>
                    </div>
                ))}
            </Accordion>
        </div>
    );
};

StoreCategoriesList.propTypes = {
    controlId: PropTypes.number.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    sectionHeading: PropTypes.string.isRequired,
};

export default StoreCategoriesList;
